export var OrganisationHeadingEnum;
(function (OrganisationHeadingEnum) {
    OrganisationHeadingEnum["Details"] = "Details";
    OrganisationHeadingEnum["Requests"] = "Requests";
    OrganisationHeadingEnum["Users"] = "Users";
    OrganisationHeadingEnum["Modules"] = "Modules";
    OrganisationHeadingEnum["PortalMapService"] = "Map services";
    OrganisationHeadingEnum["NotificationTemplates"] = "Notification templates";
    OrganisationHeadingEnum["SmsSettings"] = "SMS settings";
    OrganisationHeadingEnum["BackupAndRestore"] = "Backup and restore";
})(OrganisationHeadingEnum || (OrganisationHeadingEnum = {}));
export var RolesEnum;
(function (RolesEnum) {
    RolesEnum["OrganisationAdmin"] = "Organisation Admin";
    RolesEnum["SuperAdmin"] = "Super Admin";
    RolesEnum["ModuleAdmin"] = "Admin";
})(RolesEnum || (RolesEnum = {}));
